<div class="form-group">
    <label class="control-label">{{label}}</label>
    <select class="form-control form-control-sm" [(ngModel)]="model" (change)="change()" [disabled]="disabled">
      <option *ngFor="let o of options" [ngValue]="o.value">{{o.label | translate}}</option>
    </select>
</div>